/**
 * 模板库 —— SPEC.md §4A.5
 * 点击卡片即往聊天面板注入一条用户消息（通过 ChatPanel 的 send 逻辑实现）。
 * 卡片仅展示 图标 + 标题 + 副标题，保持简略；完整 prompt 由点击时注入。
 */
import { X } from "lucide-react";
import { TEMPLATES } from "../lib/templates";
import { useAppStore } from "../store/useAppStore";

interface Props {
  onClose: () => void;
}

export function TemplateGallery({ onClose }: Props) {
  const domain = useAppStore(s => s.domain);

  const onPick = (prompt: string) => {
    onClose();
    // 通过 CustomEvent 解耦：ChatPanel 在 mount 时监听 "aiggb:send"
    window.dispatchEvent(new CustomEvent("aiggb:send", { detail: prompt }));
  };

  // 只显示当前分类的模板
  const items = TEMPLATES.filter(t => t.domain === domain);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-wide" onClick={e => e.stopPropagation()}>
        <header className="modal-header">
          <h2>{domain === "physics" ? "物理场景模板" : "数学场景模板"}</h2>
          <button className="icon-btn" onClick={onClose} aria-label="close">
            <X size={18} />
          </button>
        </header>
        <p className="muted small">
          点击卡片即向 AI 发送对应描述，由 AI 即时生成可调参数的动图。
        </p>
        <div className="template-grid">
          {items.map(t => (
            <button key={t.id} className="template-card" onClick={() => onPick(t.prompt)}>
              <span className="template-icon">{t.icon}</span>
              <span className="template-title">{t.title}</span>
              <span className="template-subtitle">{t.subtitle}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
